import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import common from './modules/common'
import chat from './modules/chat'
import messages from './modules/messages'
import activities from './modules/activities'
import navbar from './modules/navbar'
import networking from './modules/networking'
import showrooms from './modules/showrooms'
import sessions from './modules/sessions'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    common,
    chat,
    messages,
    activities,
    navbar,
    networking,
    showrooms,
    sessions,
  },

  strict: debug
})
